import styled from "styled-components";

export const ModalJoinRestriction = styled.div`
  padding: 32px 24px 0px 24px;
`;

export const ModalHeader = styled.div`
  font-weight: 700;
`;

export const ModalContent = styled.div`
  padding: 24px 0px 24px 0px;
  font-size: 1.5rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.black80};
  word-break: keep-all;
  text-align: center;
  letter-spacing: 0.05rem;

  display: flex;
  flex-direction: column;
  gap: 0.7rem;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${(props) => props.theme.colors.black80};
  font-size: 14px;
  margin-top: 12px;

  .divider {
    width: 1.2px;
    height: 14px;
    background-color: ${(props) => props.theme.colors.black30};
  }
`;
